import { Registry } from '../registry';
import * as anchors from './main';
export var EdgeConnectionAnchor;
(function (EdgeConnectionAnchor) {
    EdgeConnectionAnchor.presets = anchors;
    EdgeConnectionAnchor.registry = Registry.create({
        type: 'edge anchor',
    });
    EdgeConnectionAnchor.registry.register(EdgeConnectionAnchor.presets, true);
})(EdgeConnectionAnchor || (EdgeConnectionAnchor = {}));
//# sourceMappingURL=index.js.map